function loadAndParseCSV(url, callback) {
    $.ajax({
        url: url,
        dataType: 'text',
        success: function(data) {
            var lines = data.split("\n");
            var headers = lines[0].split(",");
            var allData = [];
            for (var i = 1; i < lines.length; i++) {
                var cells = lines[i].split(",");
                var rowObject = {};
                headers.forEach((header, index) => {
                    rowObject[header.trim()] = cells[index] ? cells[index].trim() : ''; // Trim whitespace
                });
                allData.push(rowObject);
            }
            callback(allData);
        }
    });
}

function normalizePSC(psc) {
    return psc.replace(/\s+/g, ''); // Remove all whitespace
}

function isUniqueEntry(combinedData, ulice, cp) {
    return !combinedData.some(row => row.ulice === ulice && row['č.p.'] === cp);
}

function combineDataAndStore(csvData1, csvData2) {
    var combinedData = [];

    csvData1.forEach(row1 => {
        var normalizedPsc1 = normalizePSC(row1['PSC']);
        var matchingRows = csvData2.filter(row2 => normalizePSC(row2['PSC']) === normalizedPsc1);

        if (matchingRows.length > 0) {
            matchingRows.forEach(row2 => {
                var combinedRow = { ...row1, ...row2 };
                if (isUniqueEntry(combinedData, combinedRow.ulice, combinedRow['č.p.'])) {
                    combinedData.push(combinedRow);
                }
            });
        } else {
            if (isUniqueEntry(combinedData, row1.ulice, row1['č.p.'])) {
                combinedData.push(row1);
            }
        }
    });

    csvData2.forEach(row2 => {
        var normalizedPsc2 = normalizePSC(row2['PSC']);
        var matchingRows = csvData1.filter(row1 => normalizePSC(row1['PSC']) === normalizedPsc2);

        if (matchingRows.length === 0) {
            if (isUniqueEntry(combinedData, row2.ulice, row2['č.p.'])) {
                combinedData.push(row2);
            }
        }
    });

    sessionStorage.setItem('csvDataCombined', JSON.stringify(combinedData));
}

if (!sessionStorage.getItem('csvDataCombined')) {
    loadAndParseCSV('https://docs.google.com/spreadsheets/d/e/2PACX-1vSv6GxyjuyUS8aPucP0GcC0ar0x8zF1Uy_0liLhGgEKYafkUcLCENSxqa_N0cF196N_6ESo-Uu7xKLb/pub?gid=491913331&single=true&output=csv', function(data1) {
        loadAndParseCSV('https://docs.google.com/spreadsheets/d/e/2PACX-1vSv6GxyjuyUS8aPucP0GcC0ar0x8zF1Uy_0liLhGgEKYafkUcLCENSxqa_N0cF196N_6ESo-Uu7xKLb/pub?gid=1302963055&single=true&output=csv', function(data2) {
            combineDataAndStore(data1, data2);
        });
    });
}
